import { getStore } from 'owa-teams-policies-lazy/lib/store/store';

export function isTeamsChatPolicyEnabled(): boolean {
    const policies = getStore().policies;

    return !!(policies?.teamsUpgraded && policies?.allowUserChat && policies?.teamsFeatureEnabled);
}
